import React, { useEffect, useState } from "react";
import { useGlobal } from "../../../../../../resources/setting/global";
import Effects from "../../../../../../resources/fabricjs/Effects";
import SliderInput from "../../../../../../resources/component/general/inputs/SliderInput";
import UtilsObject from "../../../../../../resources/utils/UtilsObject";

const styles = {
  controlls: {
    display: 'block', 
    paddingLeft: 10,
    paddingRight: 10,
    // padding: 10, 
    // background: '#eeeeee', 
    // borderRadius: 7,
  }
}

const BoxBlur = (props) => {
  
  // global variables
  const {valGlobal} = useGlobal();
  // filters values
  const [blur, setBlur] = useState(0);

  // apply filter
  const apply = ( setting ) => {
    new Effects().Blur( valGlobal.canvas, props.values.index, setting );
  }

  // update this component
  const updateComponents = () => {

    UtilsObject.getActive( valGlobal.canvas ).then( object => {

      if (object.hasOwnProperty('filters') === false) return;      
      object.filters = object.filters || [];
      object.filters.forEach( el => {
        if(el.name === props.values.name){
          // set values
          setBlur(props.values.blur);
        }
      });

    }).catch(()=>{});

  };

  useEffect(() => {
    if(blur){
      const settings = {
        ...props.values,
        blur: blur,
      }
      apply(settings);
    }
  },[blur]);

  useEffect(() => {    
    updateComponents();
  },[]);

  return (
    <div style={styles.controlls}>
      <SliderInput value={blur} min={0} max={1} step={0.01} default={0} onChange={(e)=>setBlur(e.value)} isInt={false} decimal={2}/>
    </div>
  );
}
export default BoxBlur;